module.exports = __webpack_public_path__ + "img/check_20_unchecked.505b686b.svg";